import React, {useState} from 'react';
import {Button, Form, InputGroup, Modal} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faExclamationCircle, faL} from "@fortawesome/free-solid-svg-icons";
import LocalDataService from "../api/LocalDataService";
import {toast} from "react-toastify";
import ApiService from "../api/ApiService";
import {useNavigate} from "react-router-dom";


const WorkFlowExecuteModal = ({visible, cost_money,video_duration,flowId, input_data, onClose}) => {
    const [user, setUser] = useState(null);
    const api =new ApiService();
    const navigate = useNavigate();
    const [discord, setDiscord] = React.useState(1);
    React.useEffect(() => {
        if(!visible){
            return
        }
        const userData = LocalDataService.load_user_data();
        setUser(userData);
        const discount = userData.vip.level > 1 ? 0.7 : userData.vip.level > 0 ? 0.9 : 1;
        setDiscord(discount);
    }, [visible]);

    const executeTask = async (event) => {

        event.preventDefault();
        const formData = new FormData(event.target);

        try {
            const jsonData = {};
            input_data.map((item, index) => {
                const value = formData.get(item.name);
                console.log(item.name, value)
                if (item.hide){
                    jsonData[item.name] = item.defaultValue;
                }else {
                    jsonData[item.name] = value;
                }
            });
           const result = await api.executeWorkflow(flowId, jsonData);
            if (result.code === 200){
                toast.success(`执行成功`);
                navigate('/WorkFlowExecuteRecordList')
            }
        } catch (error) {
            toast.error(`执行失败: ${error.data}`);
        }
    };
    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton closeVariant="white" style={{
                background: '#1E2129',
                borderBottomColor: 'transparent'
            }}>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <Form onSubmit={executeTask}>
                    {input_data && input_data.map((item, index) => (
                        <div key={index} style={{display:item.hide?'none':'block'}}>
                            <Form.Label htmlFor="basic-url"><span
                                style={{color: '#B4BFC5', justifyContent: 'center'}}>{item.required && (
                                <span style={{color: 'red'}}>*</span>)}{item.title?item.title:item.name}</span></Form.Label>
                            <InputGroup className="mb-3">
                                {item.name === "api_token" ?
                                    <Form.Control id={item.name} name={item.name} placeholder={item.description}
                                                  value={LocalDataService.loadApiToken()} readOnly
                                                  required={item.required}/>
                                    :
                                    <Form.Control id={item.name} name={item.name} placeholder={item.description}
                                                  type={item.type}
                                                  defaultValue={item.defaultValue} required={item.required}/>} 
                            </InputGroup>
                            {item.name === "api_token" &&
                                <p style={{color: '#02C8E3'}}><FontAwesomeIcon icon={faCheck}/> 已自动填充您的API密钥
                                </p>}
                        </div>
                    ))}
                    <div className={'d-flex justify-content-end align-items-center'}>
                        <span style={{color: '#7D7D7D', marginRight: '10px'}}>
                            {video_duration > 0 ?
                            ('预估费用￥' + (cost_money / 100 / video_duration * 5*discord).toFixed(2) + '/5秒')
                            : ('单次调用预估费用:￥' + (cost_money / 100*discord).toFixed(2))}
                            <span style={{color: '#02C8E3',fontWeight: 'bold'}}>{+user?.vip?.level > 1 ?'(SVIP折扣后)': user?.vip?.level > 0 ? '(VIP折扣后)' : ''}</span>
                            </span>
                        <Button type="submit"
                                style={{
                                    background: '#02C8E3',
                                    color: '#1A1D23',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    flexShrink: 0,
                                }}>执行工作流</Button>
                        </div>
                </Form>
            </Modal.Body>
            <Modal.Footer style={{background: '#5D1717', justifyContent: "start", borderTopColor: 'transparent'}}>
                <span style={{color: '#BC2B2B', margin: 0}}><FontAwesomeIcon icon={faExclamationCircle}/> 注意：此操作将消耗官方coze账号的资源点，将会等价换成账户余额进行扣除。</span>
            </Modal.Footer>
        </Modal>

    );
};

export default WorkFlowExecuteModal;